module.exports = ["YourContract"];